import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth';
import { UserRole } from '../models';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }
  return router.parseUrl('/login');
};

export const roleGuard = (...allowedRoles: UserRole[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const role = authService.currentRole();

    if (allowedRoles.includes(role)) {
      return true;
    }
    return router.parseUrl('/');
  };
};

export const excludeRoleGuard = (...excludedRoles: UserRole[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const role = authService.currentRole();

    if (!excludedRoles.includes(role)) {
      return true;
    }
    return router.parseUrl('/');
  };
};
